import React, { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom";

import './CourseRoadMap.css';

import { testData } from '../../TestData/RoadMap'
import ThemeRoadMap from './ThemeRoadMap/ThemeRoadMap';

import api from '../../Utils/Api';
import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext';

import HorizontalTree from '../App/Common/HorizontalTree/HorizontalTree';
import Calendar from '../Calendar/Calendar';


const CourseRoadMap = ({ }) => {
    const { token } = useContext(CurrentUserContext)
    const { currentPlace, setCurrentPlace, setBreadCrumbs } = useContext(JourneyContext)
    const [roadMap, setRoadMap] = useState(undefined)
    const [selectedPoint, setSelectedPoint] = useState(undefined)

    let params = useParams();
    let selectedCourseId = parseInt(params.id)

    useEffect(() => {
        api.getRoadMap(token, selectedCourseId)
            .then((res) => {
                //console.log(res)
                setRoadMap(res)
                setBreadCrumbs(res.parents)
                setCurrentPlace(res.parents[0])
            })
            .catch((e) => {
                console.log(e);
            });
            return () => {
                setBreadCrumbs([]);
            };
    }, []);

    // useEffect(() => {
    //     api.getBreadCrumbs(token, 'course', selectedCourseId)
    //         .then((res) => {
    //             console.log(res)
    //             setCurrentPlace(res[0])
    //             setBreadCrumbs(res)
    //         })
    //         .catch((e) => {
    //             console.log(e);
    //         });
    // }, []);

    useEffect(() => {
        const allLessons = roadMap?.topics?.map(theme => theme.lessons.map(lesson => lesson))
        let allLessonsOneArray = []
        if (allLessons) {
            for (let i = 0; i < allLessons?.length - 1; i++) {
                allLessonsOneArray = allLessonsOneArray.concat(allLessons[i])
            }
            const activeLesson = allLessonsOneArray.filter(lesson => lesson.is_active)
            // console.log(activeLesson)
            setSelectedPoint(activeLesson[0]?.id)
        }
    }, [roadMap]);

    // console.log(testData)

    const [tab, setTab] = useState(false)
    const [titleTag, setTitle] = useState('')
    const handleOpenTab = (title) => {
        if (title === 'Все курсы') {
            setTab(false)
            setTitle('_courses')
        } else if (title === 'Календарь') {
            setTab(true)
            setTitle('_calendar') 
        }
      }
    return (
        roadMap && <div className='roadmap__wrapper'>
             
            <div className='rodamap__wrap'>
            <div className='tab__wrap'>
              <div className={'tab__btn' + (titleTag ? titleTag === '_courses' : 'true')} onClick={() => handleOpenTab('Все курсы')}>Темы</div>
              {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
            </div>
            {tab && <div className='courses__calendar'><Calendar></Calendar></div>}
            {!tab &&
             <div className='roadmap__container openedBlock__container'>
            {/* <div className='performance__navTree'>
                <div >Главная</div>
                <div className='current'>{currentPlace.title}</div>
            </div> */}
       

           
            {/* <HorizontalTree /> */}
            <div className='roadmap__themes'>
                {roadMap.topics.length > 0 && roadMap.topics.map((theme, index) => (
                    <div className='roadmap__theme' key={theme.id}>
                        <ThemeRoadMap theme={theme} lessons={theme.lessons} key={theme.id} selectedPoint={selectedPoint} setSelectedPoint={setSelectedPoint} />
                        {index < roadMap.topics.length - 1 && <div className={`roadmap__decoration ${roadMap[index + 1]?.percent_completed > 0 ? 'roadmap__decoration_blue' : 'roadmap__decoration_grey'}`} />}
                    </div>
                ))}
            </div>
            </div>}
            </div>
        </div>

    )
}
export default CourseRoadMap
